import { CountDownTime, CountDownTitle } from '../../atoms';

export const CountDownTimer = () => {
    return (
        <>
            <CountDownTitle />
            <CountDownTime />
        </>
    );
};
